import { styled } from "styled-components";
import { AppColors } from "../styles/colors";
import BtnElement from "../elements/BtnElement";
import { AppTextStyles } from "../styles/textStyles";
import TermsBottomSheet from "./TermsBottomSheet";


const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ModalHeader = styled.div<{ $isSingle: boolean }>`
  display: flex;
  justify-content: ${({ $isSingle }) => $isSingle ? 'flex-start' : 'space-between'};
  align-items: center;
  border-bottom: ${({ $isSingle }) => $isSingle ? 'none' : `1px solid ${AppColors.onInput3}`};
  margin-bottom: 16px;
`;

const ModalTitle = styled(BtnElement)<{ $isActive: boolean; $isSingle: boolean }>`
  font-size: ${({ $isSingle }) => $isSingle ? '18px' : '14px'};
  font-weight: ${({ $isSingle }) => $isSingle ? '700' : '600'};
  margin: 0;
  flex: ${({ $isSingle }) => $isSingle ? 'none' : '1'};
  color: ${({ $isActive, $isSingle }) =>
    $isSingle ? '#262626' : ($isActive ? `${AppColors.onInput5}` : `${AppColors.onInput2}`)};
  border-radius: 0;
  border-bottom: ${({ $isActive, $isSingle }) =>
    $isSingle ? 'none' : ($isActive ? `1.6px solid ${AppColors.onInput3}` : "none")};
  white-space: pre-line;
  text-align: ${({ $isSingle }) => $isSingle ? 'left' : 'center'};
  line-height: 1.3;
`;

const ModalBody = styled.div`
  flex: 1;
  white-space: pre-wrap;
  text-align: justify;
  background-color: ${AppColors.onPopup};
  padding: 0 16px;
  ${AppTextStyles.body3}
  overflow-y: auto;
  max-height: calc(90vh - 200px); /* 헤더와 버튼 영역을 제외한 높이 */
  
  /* 스크롤바 스타일링 */
  scrollbar-width: thin;
  scrollbar-color: ${AppColors.onInput3} transparent;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: ${AppColors.onInput3};
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${AppColors.onInput2};
  }
`;

interface TermsSection {
  key: string;
  title: string;
  content: string;
}

interface TermsConsentSheetProps {
  sections: TermsSection[];
  viewedSection: string;
  onClose: () => void;
  onSectionClick: (sectionKey: string) => void;
  isLoading?: boolean;
  loadingText?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export default function TermsConsentSheet({
  sections,
  viewedSection,
  onClose,
  onSectionClick,
  isLoading = false,
  loadingText = "로딩 중...",
  buttonText,
  onButtonClick
}: TermsConsentSheetProps) {
  const currentSection = sections.find(section => section.key === viewedSection);
  const isSingleSection = sections.length === 1;

  return (
    <TermsBottomSheet 
      isOpen={true}
      onClose={onClose}
      buttonText={buttonText}
      onButtonClick={onButtonClick}
    >
      <Container>
        <ModalHeader $isSingle={isSingleSection}>
          {sections.map((section) => (
            <ModalTitle
              key={section.key}
              onClick={() => onSectionClick(section.key)}
              $fullWidth={false}
              $size="medium"
              $variant="text"
              $isActive={viewedSection === section.key}
              $isSingle={isSingleSection}
            >
              {section.title}
            </ModalTitle>
          ))}
        </ModalHeader>
        <ModalBody>
          {isLoading ? (
            loadingText
          ) : (
            <div dangerouslySetInnerHTML={{ __html: currentSection?.content || "내용을 불러올 수 없습니다." }} />
          )}
        </ModalBody>
      </Container>
    </TermsBottomSheet>
  );
}
